import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/loan-operation'

const LoanOperationApi = {
  generate (loanStatus, portfolioList, category, success, failure) {
    return ajax.post(
      `${BASE_URL}/generate`,
      {
        loanStatus: loanStatus,
        portfolioList: portfolioList,
        category: category
      },
      success,
      failure
    )
  },
  renewLock (loanId, token, success, failure) {
    return ajax.post(
      `${BASE_URL}/lock/renew`,
      {
        loanId: loanId,
        token: token
      },
      success,
      failure
    )
  },
  addNote (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/add-note`,
      input,
      success,
      failure
    )
  },
  lockLoan (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lock`,
      input,
      success,
      failure
    )
  },
  unlockLoan (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/unlock`,
      input,
      success,
      failure,
      { couldCancel: false }
    )
  },
  grabLockedLoan (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/grab`,
      input,
      success,
      failure
    )
  },
  changeSlaveLoanStatus (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/slave-loan/change-status`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  batchUpdateStatus (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/batch-update-status `,
      input,
      success,
      failure
    )
  },
  customerSearch (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/customer-search`,
      input,
      success,
      failure
    )
  },
  exportWorkQueueData (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/export`,
      input,
      success,
      failure
    )
  },
  hasLockedLoan (success, failure) {
    return ajax.get(
      `${BASE_URL}/pre-generate`,
      null,
      success,
      failure
    )
  }
}
export { LoanOperationApi }
